module.exports = __webpack_public_path__ + "static/img/icon2.2c2d083.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon2.png
// module id = 8FPX
// module chunks = 1